import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { AssignmentGroup } from 'app/models/dto/lead-assignment/assignment-group.model';
import { lastValueFrom, Observable } from 'rxjs';
import { Lender } from 'app/models/dto/lead-assignment/lender.model';
import { GroupUnclaimed } from 'app/models/dto/lead-assignment/group-unclaimed.model';
import { Classification } from 'app/models/dto/lead-assignment/classification.model';
import { Source } from 'app/models/dto/lead-assignment/source.model';
import { Group } from 'app/models/dto/lead-assignment/group.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { MarketingQualifiedLead } from 'app/models/dto/lead-assignment/marketing-qualified-lead.model';

interface UnclaimedTotal {
  total: number;
}

@Injectable({
    providedIn: 'root'
})

export class LeadAssignmentService {

    constructor(
        private http: ApiHttpClient
    ) {}

    getAssignmentGroups(): Observable<AssignmentGroup[]> {
        return this.http.get<AssignmentGroup[]>('/assignment-group');
    }

    getLeadAssignmentGroups(): Observable<AssignmentGroup[]> {
      return this.http.get<AssignmentGroup[]>('/assignment-group-lead-assignment');
    }

    getClassifications(): Observable<Classification[]> {
      return this.http.get<Classification[]>('/assignment-group-classifications');
    }

    getSources(): Observable<Source[]> {
      return this.http.get<Source[]>('/partners');
    }

    getTeamLenderUsers(id, assignmentGroupId): Observable<Lender[]> {
      return this.http.post<Lender[]>(`/team-members-for-assignment-group/${id}`, {assignmentGroupId});
    }

    getAssignmentGroupUnclaimedBorrowers(id: number): Observable<Borrower[]> {
      return this.http.get<Borrower[]>(`/assignment-group-unclaimed/${id}`);
    }

    getMQLCount(): Observable<string> {
      return this.http.get<string>('/leads/counts/mql');
    }

    getMQLs(): Observable<MarketingQualifiedLead[]> {
      return this.http.get<MarketingQualifiedLead[]>('/leads/mql');
    }

    postUnclaimedPreviewCount(id, group): Observable<GroupUnclaimed> {
      return this.http.post<GroupUnclaimed>(`/assignment-group-preview-unclaimed/${id}`, group);
    }

    putUpdateOrdering(type, ordering): Promise<AssignmentGroup[]> {
      return lastValueFrom(this.http.put<AssignmentGroup[]>('/assignment-group-order', {
        type,
        ordering
      }));
    }

    createAssignmentGroup(groupName: string): Observable<Group> {
      return this.http.post<Group>('/assignment-group', { name: groupName });
    }

    updateAssignmentGroup(id: number, assignmentGroup: AssignmentGroup): Observable<AssignmentGroup> {
      return this.http.put<AssignmentGroup>(`/assignment-group/${id}`, assignmentGroup);
    }

    deleteAssignmentGroup(id: number): Observable<void> {
      return this.http.delete<void>('/assignment-group/' + id);
    }

    getUnclaimedBorrowersTotal(id: number): Observable<UnclaimedTotal> {
      return this.http.get<UnclaimedTotal>(`/assignment-group-unclaimed/${id}`);
    }
  }
